import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import Select from './Select';
import { CheckboxOption } from './components/input-options';
const CheckboxSelectInternal = ({
  components,
  ...props
}) => {
  const mergedComponents = useMemo(() => ({
    ...components,
    Option: CheckboxOption
  }), [components]);
  return /*#__PURE__*/React.createElement(Select, _extends({
    closeMenuOnSelect: false,
    hideSelectedOptions: false,
    isMulti: true
  }, props, {
    components: mergedComponents
  }));
};
const CheckboxSelect = /*#__PURE__*/React.memo(CheckboxSelectInternal
// Type casting as `React.memo` does not forward generic types
// Reference: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/37087#issuecomment-656596623
);
export default CheckboxSelect;